import { useState } from "react";
import { Tag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/lib/categories";
import { track } from "@/lib/track";

function Deal({ item, deal }) {
  const [shown, setShown] = useState(false);
  const claim = () => { setShown(true); track(item, "deal_claim", deal.id); };
  return (
    <div data-testid={`deal-${deal.id}`} className="rounded-2xl border border-[#FF3B6B]/40 bg-[#FF3B6B]/10 p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-bold text-white flex items-center gap-1.5"><Tag className="h-4 w-4 text-[#FF3B6B]" /> {deal.title}</p>
          {deal.details && <p className="text-sm text-slate-300 mt-1">{deal.details}</p>}
          <p className="text-xs text-slate-400 mt-1">Ends {fmtDate(deal.ends)}</p>
        </div>
        {!shown && <Button data-testid={`deal-claim-${deal.id}`} size="sm" onClick={claim} className="rounded-full bg-[#FF3B6B] hover:bg-[#E02E5A] text-white font-semibold shrink-0">Claim</Button>}
      </div>
      {shown && (
        <p data-testid={`deal-code-${deal.id}`} className="mt-3 text-sm rounded-xl bg-[#0B0F19] border border-dashed border-[#FF3B6B] px-3 py-2 text-center">
          {deal.code ? <>Use code <span className="font-mono-vv font-bold text-[#FF3B6B]">{deal.code}</span></> : "Show this screen at the venue to redeem"}
        </p>
      )}
    </div>
  );
}

export function DealBox({ item }) {
  if (!item.deals?.length) return null;
  return <div className="space-y-2">{item.deals.map((d) => <Deal key={d.id} item={item} deal={d} />)}</div>;
}
